// Libraries
import { Checkbox, CheckboxProps, Flex } from '@chakra-ui/react';

/**
 * IndeterminateCheckbox component.
 *
 * @param {Object} props - The component props.
 * @param {...CheckboxProps} rest - The rest of the Checkbox component props.
 * @returns {ReactElement} - The JSX element representing the IndeterminateCheckbox component.
 *
 * @example
 *
 *      <IndeterminateCheckbox
 *         {...{
 *          isChecked: checkedState,
 *          isIndeterminate: indeterminateState,
 *          onChange: onChangeFunction,
 *        }}
 *      />
 */
export const IndeterminateCheckbox = ({ ...rest }: CheckboxProps) => {
  return (
    <Flex justifyContent='center'>
      <Checkbox {...rest} />
    </Flex>
  );
};
